/* jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';
import FormattedRelativeWrapper from 'app/components/common/FormattedRelativeWrapper.jsx';

class CardlessTrialBanner extends React.Component {
    constructor(props) {
        super(props);

        this.onClick = this.onClick.bind(this);

    }

    componentDidMount() {
        // if (dataLayer) {
        //     dataLayer.push({
        //         'event': 'promotionView',
        //         'ecommerce': {
        //             'promoView': {
        //                 'promotions': [
        //                     {
        //                         'id': 'freetrial_banner',
        //                         'name': 'Free Trial Banner',
        //                         'creative': 'freetrial_banner.1',
        //                         'position': 'top-promo-bar'
        //                     }
        //                 ]
        //             }
        //         },
        //         //GA 4 params
        //         'promotion_id': 'freetrial_banner',
        //         'promotion_name': 'Free Trial Banner',
        //         'creative_name': 'freetrial_banner.1',
        //         'creative_slot': 'top-promo-bar',
        //         items: [
        //             {
        //                 item_id: 'dlvrit_1',
        //                 item_name: 'dlvr.it premium plan',
        //                 price: 1.00,
        //                 quantity: 1
        //             }
        //         ]
        //     });
        // }

        if (gtag) {
            gtag('event', 'view_promotion', {
                'promotion_id': 'freetrial_banner',
                'promotion_name': 'Free Trial Banner',
                'creative_name': 'freetrial_banner.1',
                'creative_slot': 'top-promo-bar',
                items: [
                    {
                        item_id: 'dlvrit_1',
                        item_name: 'dlvr.it premium plan',
                        price: 1.00,
                        quantity: 1
                    }
                ]
            });
        }

    }

    onClick(e) {

        let that = this;

        // if (dataLayer && window.ga && ga.loaded) {
        //     dataLayer.push({
        //         'event': 'promotionClick',
        //         'ecommerce': {
        //             'promoClick': {
        //                 'promotions': [
        //                     {
        //                         'id': 'freetrial_banner',
        //                         'name': 'Free Trial Banner',
        //                         'creative': 'freetrial_banner.1',
        //                         'position': 'top-promo-bar'
        //                     }
        //                 ]
        //             }
        //         },
        //         //GA 4 params
        //         'promotion_id': 'freetrial_banner',
        //         'promotion_name': 'Free Trial Banner',
        //         'creative_name': 'freetrial_banner.1',
        //         'creative_slot': 'top-promo-bar',
        //         items: [
        //             {
        //                 item_id: 'dlvrit_1',
        //                 item_name: 'dlvr.it premium plan',
        //                 price: 1.00,
        //                 quantity: 1
        //             }
        //         ]
        //     });
        // }

        if (gtag) {
            gtag('event', 'select_promotion', {
                'promotion_id': 'freetrial_banner',
                'promotion_name': 'Free Trial Banner',
                'creative_name': 'freetrial_banner.1',
                'creative_slot': 'top-promo-bar',
                items: [
                    {
                        item_id: 'dlvrit_1',
                        item_name: 'dlvr.it premium plan',
                        price: 1.00,
                        quantity: 1
                    }
                ]
            });

            this.props.persistData('gaPromo', {
                'promotion_id': 'freetrial_banner',
                'promotion_name': 'Free Trial Banner',
            });

        }

    }

    render() {
        let iconUrl = [this.props.app.config.assetsUrl, 'images', 'd-white.png'].join('/'),
            link = '/account/subscription?subscribe=true',
            date = (this.props.user.plan.trialEndsAt) ? <FormattedRelativeWrapper value={this.props.user.plan.trialEndsAt}/> : '',
            content = 'Your trial ends ';

        if (date == '') {
            content = 'Your trial has ended';
        } else {
            content = content + date;
        }

        return (
            <div>
                <div className="icon-wrapper">
                    <img src={iconUrl} style={{verticalAlign: 'middle', marginTop: '5px'}}/>
                </div>
                <span>{content}. Lock in the benefits of dlvr.it. <a href={link} onClick={this.onClick}>Complete Upgrade Now</a></span>
            </div>
        );
    }

};

CardlessTrialBanner.propTypes = {
    context: PropTypes.string
};

CardlessTrialBanner.defaultProps = {
    context: 'app'
};

export default CardlessTrialBanner;
